module.exports = __webpack_public_path__ + "static/media/print.8f1936a6.svg";